import { getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createEmployeeDeductionRequestsSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.EMPLOYEE_DEDUCTION_REQUEST,
        ...getUserAndEventTime(),
        data: {
            uri: 'https://api.atomicfi.com/employers/642c9aa6f8fc90e0dbb4c92f/employee-deduction-requests?taskId=6501f8249f904b6a29e6cc1c',
            employerId: '642c9aa6f8fc90e0dbb4c92f',
            employeeDeductionRequests: [
                {
                    state: 'applied',
                    trackingId: '0b6385c9-f1e4-4b3c-8881-3c8b124609e1',
                    employee: '642df289af36e2ef5e1679dc',
                    employerDeductionType: '64c3d74f9326b2e09de96089',
                    task: '6501f8249f904b6a29e6cc1c',
                    employeeDeduction: {
                        _id: '6508ca7ebc39bd78ca1fb87d',
                        label: 'retirement',
                        calculation: 'fixed',
                        category: '401k',
                        categoryType: 'post-tax',
                        amount: 4,
                        startDate: '2023-09-13T17:57:56.230Z'
                    }
                },
                {
                    state: 'failed',
                    trackingId: '9681a900-d7a1-4fd2-a5da-0f1f3335dfcf',
                    employee: '642df289af36e2ef5e1679d9',
                    employerDeductionType: '64c3d74f9326b2e09de96089',
                    task: '6501f8249f904b6a29e6cc1c',
                    employeeDeduction: {
                        _id: '6508ca8b882f46254b6934b7',
                        label: 'retirement',
                        calculation: 'percent',
                        category: 'other',
                        categoryType: 'pre-tax',
                        amount: 20,
                        startDate: '2023-09-13T17:57:56.230Z'
                    }
                }
            ]
        }
    };
};
//# sourceMappingURL=employee-deduction-requests.js.map